import { render, staticRenderFns } from "./RecordingServers.vue?vue&type=template&id=09167b0a&scoped=true"
import script from "./RecordingServers.vue?vue&type=script&lang=js"
export * from "./RecordingServers.vue?vue&type=script&lang=js"
import style0 from "./RecordingServers.vue?vue&type=style&index=0&id=09167b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09167b0a",
  null
  
)

export default component.exports